import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isDesktop } from "isDesktop";
import "./style.less";
import { Headline } from "src/Common/Theme/Typography";
import { 
	 partBrandsHeaderVn
	} from "./Constants/Constants"

import { REGIONS } from "src/Services/RegionGetter/Constants";

export const ParticipatingBrands = (props) => {

  const { brandIcons } = props

  // reducer
  const regionLanguage = useSelector((state) => state.RegionLanguageReducer);
  const { region, language } = regionLanguage;

  // state
  const [partBrandsHeader, setpartBrandsHeader] = useState("");
  const [participatingIcons, setParticipatingIcons] = useState("");

  let iconsJson = [];
  for (const [key, value] of Object.entries(participatingIcons)) {
    iconsJson.push({ key, value });
  }

  // effect
  useEffect(() => {
    switch (true) {
      case region === REGIONS.vietnam:
			  setpartBrandsHeader(partBrandsHeaderVn);
        setParticipatingIcons(brandIcons);
  
		  break;
      default:
    }
  }, [language, region]);

  return (
    <>
      {/* Desktop */}
      {isDesktop() && (
        <div className="PartBrands">
          <Headline shopee bold h1 className="PartBrands__ContentSubtitle">
            {partBrandsHeader}
          </Headline>
          <div className="PartBrands__MerchantLogoWrapper">
            <div className="PartBrands__MerchantLogos">
              {iconsJson.map((icon, index) => (
                <img
                  className="PartBrands__MerchantLogos__Img"
                  key={index}
                  src={icon.value}
                  width="100px"
                  alt="merchantLogo"
                />
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Mobile */}
      {!isDesktop() && (
        <div className="PartBrandsMobile">
          <Headline shopee bold h1 className="PartBrandsMobile__ContentTitle">
            {partBrandsHeader}
          </Headline>
          <div className="PartBrandsMobile__LogoWrapper">
            <div className="PartBrandsMobile__Logos">
              {iconsJson.map((icon, index) => (
                <img
                  className="PartBrandsMobile__Logos__Img"
                  key={index}
                  src={icon.value}
                  alt="merchantLogo"
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
